import { render, staticRenderFns } from "./textBlock.vue?vue&type=template&id=e90bc08e"
import script from "./textBlock.vue?vue&type=script&lang=js"
export * from "./textBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports